const account = {
	name: 'Account | Accounts',
	fields: {
		hp_id: 'Account No.',
		account_name: {
			name: 'Name',
		},
		account_type: 'Type',
		accounting_year: {
			year: 'Year',
		},
		journals_count: 'Journals',
		comments_count: 'Comments',
		balances: 'Balances',
	},
}

export default account
